import { HttpError } from "../../../http/Types";

/**
 * The server states the actionable reason a token request was refused — the cap, a wrong code, a
 * lockout — so its message is what the admin needs to read. A rejection that never reached the
 * server carries no such message, which is what the fallback stands in for.
 */
export function httpErrorMessage(error: unknown, fallback: string): string {
  const message = (error as HttpError | undefined)?.message;
  return typeof message === "string" && message.length > 0 ? message : fallback;
}
